export default "__VITE_ASSET__BhzBRQdk__"